import { render, staticRenderFns } from "./ChartWidgetCasePriority.vue?vue&type=template&id=41da23c0&scoped=true&"
import script from "./ChartWidgetCasePriority.vue?vue&type=script&lang=js&"
export * from "./ChartWidgetCasePriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41da23c0",
  null
  
)

export default component.exports